import appConfig from "./appConfig";

var accontKey = "account";
var mailKey = "mailaddress";
var tokenKey = "tokenObj";
var loginKey = "login";
var enableNFCKey = "nfc";
var tenantKey = "tenant";
var pushTokenKey = "pushtoken";
var roomCriteria = "roomCriteria";
var searchResultKey = "searchResult";

/**
 * グローバル変数から取得
 */
function getFromGlobalVar(key) {
  return window[`tretter-${key}`];
}
/**
 * グローバル変数への設定
 */
function setToGlobalVar(key, value) {
  window[`tretter-${key}`] = value;
}
/**
 * ローカルストレージから取得
 */
function getFromStorage(key) {
  return localStorage.getItem(key);
}
/**
 * ローカルストレージへの設定
 */
function setToStorage(key, value) {
  localStorage.setItem(key, value);
}
/**
 * ローカルストレージから削除
 */
function removeFromStorage(key) {
  localStorage.removeItem(key);
}

class Store {
  constructor() {
    this.expandAppendSubject = "-延長-";
    this.simpleBookSubject = `${appConfig.systemName}から予約`;
  }

  /**
   * ログイン情報を取得します
   */
  get loginInfo() {
    return JSON.parse(getFromStorage(loginKey));
  }
  set loginInfo(value) {
    {
      removeFromStorage(loginKey);
    }
    setToStorage(loginKey, JSON.stringify(value));
  }
  /**
   * アカウントを取得します
   */
  get account() {
    return getFromStorage(accontKey);
  }
  set account(value) {
    setToStorage(accontKey, value);
  }
  /**
   * メアドを取得します
   */
  get mail() {
    return getFromStorage(mailKey);
  }
  set mail(value) {
    setToStorage(mailKey, value);
  }
  /**
   * NFCが可能します
   */
  get enableNFC() {
    return getFromStorage(enableNFCKey);
  }
  set enableNFC(value) {
    setToStorage(enableNFCKey, value);
  }
  /**
   * プッシュ通知のデバイストークン
   */
  get pushToken() {
    return getFromStorage(pushTokenKey);
  }
  set pushToken(value) {
    setToStorage(pushTokenKey, value);
  }
  /**
   * テナント情報を取得します
   */
  get tenant() {
    return JSON.parse(getFromStorage(tenantKey));
  }
  set tenant(value) {
    setToStorage(tenantKey, JSON.stringify(value));
  }
  /**
   * 会議室検索条件
   */
  get roomCriteria() {
    return JSON.parse(getFromStorage(roomCriteria));
  }
  set roomCriteria(value) {
    setToStorage(roomCriteria, JSON.stringify(value));
  }
  /**
   * トークンを取得します
   */
  get token() {
    return JSON.parse(getFromStorage(tokenKey));
  }
  set token(value) {
    if (!value) {
      removeFromStorage(tokenKey);
      return;
    }
    setToStorage(tokenKey, JSON.stringify(value));
  }
  /**
   * 検索結果を取得します
   */
  get searchResult() {
    return getFromGlobalVar(searchResultKey);
  }
  set searchResult(value) {
    setToGlobalVar(searchResultKey, value);
  }
}

export default Store;
